$(document).ready(function () {
   'use strict';

   var $container = $('.js-volunteers-form');

   if ($container.length) {
       var MAX_ADDITIONAL_LANGUAGE = 2;

       var $selects = $container.find('.js-select2');
       var $dateOfBirthInput = $container.find('.js-date-of-birth');
       var $phoneInput = $container.find('.js-phone');
       var $genderRadioHolder = $container.find('.js-gender-select');
       var $genderDependSelects = $container.find('.js-gender-depend-select');
       var $additionalLanguageFields = $container.find('.js-additional-language-field');
       var $additionalLanguageAddButton = $container.find('.js-additional-language-add');
       var currentAdditionalLanguage = 0;
       var $checkboxHolder = $container.find('.js-checkbox-holder');

       $phoneInput.inputmask('+[99999999999999]', {
           placeholder: '',
       });

       $dateOfBirthInput.inputmask({
           alias: 'datetime',
           inputFormat: 'dd.mm.yyyy',
           placeholder: '__.__.____'
       });

       /**
        * Замена опшинов в селектах по полу
        */
       var processGenderSelects = function () {
          var val = $genderRadioHolder.find('input:checked').val();
          var isMale = $genderRadioHolder.data('male') == val;
            var dataValues = isMale ? 'male' : 'female';
           $genderDependSelects.each(function() {
               var $select = $(this);
               var values = $select.data(dataValues);
               $select.empty();
               for (var valuesKey in values) {
                   var newOption = new Option(values[valuesKey], valuesKey, false, false);
                   $select.append(newOption);
               }

           });
       }

       /**
        * Показать поля для дополнительного языка
        */
       var showAdditionalLanguageField = function () {
           var index = currentAdditionalLanguage;
           var $currentField = $additionalLanguageFields.eq(index);

           if (typeof $currentField === 'undefined') {
               return;
           }

           var $select = $currentField.find('.js-additional-language-select2');

           $currentField.show();

           $select.each(function () {
               var $target = $(this);

               $target.select2({
                   'dropdownParent': $target.closest('.form-group-input'),
                   'placeholder': "Выберите / Select",
               });
           });

           currentAdditionalLanguage = currentAdditionalLanguage + 1;

           if (currentAdditionalLanguage === MAX_ADDITIONAL_LANGUAGE) {
               $additionalLanguageAddButton.addClass('full');
           }
       };

       var checkCountCheckedCheckbox = function ($holder) {
           return $holder.find('input[type="checkbox"]:checked').length;
       }

       var checkMoreActiveCheckbox = function ($holder) {
            var countChecked = checkCountCheckedCheckbox($holder);

            return countChecked <= 3;
       };

       /**
        * Обработчик клика на добавления языка
        */
       var additionalButtonClickHandler = function () {
            if (currentAdditionalLanguage >= MAX_ADDITIONAL_LANGUAGE) {
                return;
            }

           showAdditionalLanguageField();
           $additionalLanguageAddButton.eq(0).closest('.form-group')
               .hide();
       };


       var checkboxClickHandler = function (evt) {
           var $target = $(this);
           var $holder = $target.closest('.js-checkbox-holder');
           var $inputHolder = $holder.find('input:not(:checked)').closest('.checkbox-label');
           var isCanMoreChecked = checkMoreActiveCheckbox($holder);
           var countChecked = checkCountCheckedCheckbox($holder);

           if (isCanMoreChecked) {
               if (countChecked === 3) {
                   $inputHolder.addClass('disabled');
               } else {
                   $inputHolder.removeClass('disabled');
               }
               return;
           }

           evt.preventDefault();
           $inputHolder.addClass('disabled');

       };

       $genderRadioHolder.on('change', 'input', function() {
           processGenderSelects();
       });

       $container.on('click', '.js-additional-language-add', additionalButtonClickHandler);
       $checkboxHolder.on('click', 'input', checkboxClickHandler);

       // init
       processGenderSelects();
   }
});
